import urls from './environments.json';

// const environment = process.env.REACT_APP_ENVIRONMENT || 'DEV'; // Ambiente predeterminado 'DEV' o Null si es producción
const environment = null; // Ambiente predeterminado 'DEV' o Null si es producción

/**
 * Obtiene la configuración por defecto según el host y el ambiente especificados.
 * @param {string} host - Host personalizado.
 * @param {string} environment - Ambiente especificado.
 * @returns {string} - URL de configuración por defecto.
 */
const getDefaultConfig = (host, environment) => {
  if (host && !environment) {
    return `//${host}`;
  }
  return urls[environment] || urls.DEV;
};

// En caso de requerir combinar environments podemos sustituir la variable environment por el ambiente deseaado es decir
// se llamaria a la funcion getDefaultConfig con el ambiente deseado getDefaultConfig(host, 'ACA')

export function getHostApi(host) {
  return `${getDefaultConfig(host, environment)}/api/v2`;
}

export function getHostApiV1(host) {
  return `${getDefaultConfig(host, environment)}/api/v1`;
}

export function getHostCMS(host) {
  // Retorna la URL del CMS según el ambiente configurado
  // para hacer mixins con otros ambientes se puede sustituir la variable environment por el ambiente deseado
  // ejemplo: return `${urls['ACA'] || urls.DEV}/cms/api/v1`;
  const cmsUrl = `${getDefaultConfig(host, environment)}`;
  return cmsUrl + '/cms/api/v1';
}

export function getHostApiCognito(host) {
  return `${getDefaultConfig(host, environment)}/api`;
}

export function getHostApiV4(host) {
  return `${getDefaultConfig(host, environment)}/api/v4`;
}

export function getHostApiV5(host) {
  return `${getDefaultConfig(host, environment)}/api/v5`;
}

export function getHostApiMicros() {
  return 'https://amx-c-';
}

/**
 * Arma el endpoint del servicio de reservación PNR (/cx/api/reservation/pnr).
 * Si la variable `environment` de este archivo tiene valor, se usa la URL de ese
 * ambiente definida en environments.json (ej. https://rc.amlab7.com).
 * Si `environment` es null, se toma el host directo de la URL (ej. //int.amlab7.com),
 * heredando el protocolo actual del navegador.
 * @param {string} host - Host actual de la URL (window.location.host).
 * @returns {string} - Endpoint completo del servicio PNR.
 */
export function getHostReservationPnr(host) {
  return `${getDefaultConfig(host, environment)}/cx/api/reservation/pnr`;
}